<template>
  <div>
    <!-- POST APIに日程選択が必須であれば表示される日付選択コンポーネント -->
    <DialogSelectDate
      v-if="isDateRequired"
      :requestCode="couponCodeForApi"
      @parentMethod="changeDateRequired"
    />

    <!---全体を囲む--->
    <div v-else class="code-input-page">
      <TheCCInputForm
        v-model:propCode="inputtedCouponCode"
        :onChanged="changeCouponCode"
        :clickedOk="getTicketWithCouponCode"
      />

      <!-- ローディングダイアログ -->
      <DialogLoading ref="DialogLoading" />

      <!-- 認証失敗 コードミス -->
      <DialogCouponCodeFails ref="DialogCouponCodeFails" />

      <!-- 認証失敗 使用済み -->
      <DialogUsedCouponCode ref="DialogUsedCouponCode" />

      <!-- 認証失敗 引き換え期間外 -->
      <DialogExpiredCouponCode ref="DialogExpiredCouponCode" />
    </div>
  </div>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import API from "@/API";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "CouponCode",
  setup() {
    const store = useStore();
    const router = useRouter();

    const inputtedCouponCode = ref("");
    const isDateRequired = ref(false);
    const couponCodeForApi = computed(() => inputtedCouponCode.value.split(" ").join("").toUpperCase());

    const DialogLoading = ref(null);
    const DialogCouponCodeFails = ref(null);
    const DialogUsedCouponCode = ref(null);
    const DialogExpiredCouponCode = ref(null);

    const changeCouponCode = (code) => {
      // 英大文字・数字のみ
      // eslint-disable-next-line no-useless-escape
      while (code.match(/[^A-Z^a-z\d\-]/)) {
        // eslint-disable-next-line no-useless-escape
        code = code.replace(/[^A-Z^a-z\d\-]/, "");
      }

      // 4文字別れになるよう空欄を挿入、undefinedなら空文字列
      inputtedCouponCode.value = code
        ? code.match(new RegExp(".{1,4}$|.{1,4}", "g")).join(" ")
        : "";
    }

    const changeDateRequired = (status) => {
      isDateRequired.value = status;
    }

    const getTicketWithCouponCode = async() => {
      DialogLoading.value.openDialog();

      try {
        // 入力されたコードで該当Master情報取得しそのレスポンスのstart_date_conditionを参照
        var type = (await API.getVoucherMasterBook(couponCodeForApi.value))
          .start_date_condition;
        console.log("type :>> ", type);

        // typeによって分岐("today","anytime","required")する
        if (type == "today" || type == "anytime") {
          await postAPIBookGroupWithVoucher();
          DialogLoading.value.closeDialog();
        } else if (type == "required") {
          // requiredは日付選択UIが必須
          DialogLoading.value.closeDialog();
          changeDateRequired(true);
        }
      } catch (err) {
        // 存在しないバウチャーの場合
        console.log("err :>> ", err);
        DialogLoading.value.closeDialog();
        DialogCouponCodeFails.value.openDialog();
      }
    }

    
    // private
    const errorHandler = (err) => {
      switch (err.response.data.message) {
        case "引き換え可能期間外です":
          DialogExpiredCouponCode.value.openDialog();
          break;
        default:
          DialogUsedCouponCode.value.openDialog();
          break;
      }
    }
    
    // private
    const postAPIBookGroupWithVoucher = async() => {
      try {
        // POST API
        await API.createBookGroupWithVoucher({
          code: couponCodeForApi.value,
        });

        // 計測用 ネイティブコール
        await nativeHandlerService.ncCouponComplete(couponCodeForApi.value);

        redirectToBookBookingResult();
      } catch (err) {
        console.log("err :>> ", err);
        DialogLoading.value.closeDialog();
        // エラーハンドリングを行うこと
        errorHandler(err);
      }
    } 

    // private
    const redirectToBookBookingResult = () => {
      const bookGroup = store.getters['ticketing/bookGroup']
      const masterBook = store.getters['ticketing/masterBook']

      router.push({
        name: "BookBookingResult",
        params: {
          id: masterBook.id,
          book_group_id: bookGroup.id,
        },
        query: {
          voucher: true,
          language: store.getters["common/lang"],
        },
      });
    }

    return {
      inputtedCouponCode,
      isDateRequired,
      couponCodeForApi,
      DialogLoading,
      DialogCouponCodeFails,
      DialogUsedCouponCode,
      DialogExpiredCouponCode,
      changeCouponCode,
      changeDateRequired,
      getTicketWithCouponCode,
    }
  }
};
</script>

<style lang="scss" scoped>
.code-input-page {
  height: 100vh;
  width: 100vw;
}
</style>
